import { getSetApiData } from "@/services/api-service/get-set-api-data";
import { EHttpMethod } from "@/services/api-service/enums";
import { ICallAndSetData } from "@/services/api-service/interface";

const PAYMENT_URL = "/v1/erp-service/pay/send-document-to-client-for-payment";
const DOCUMENT_CONTACT_URL = "/v1/erp-service/documents/get-document-contact";
const GET_PRE_PAYMENT_BY_ID_URL = "/v1/erp-service/pay/get-pre-payment-by-id";
const GET_STRIPE_PAYMENT_REDIRECT_URL =
  "/v1/erp-service/pay/get-stripe-payment-redirect-url";
const COMPLETE_STRIPE_PAYMENT_REQUEST_URL =
  "/v1/erp-service/pay/complete-stripe-payment-request";
const SEND_PRE_PAYMENT_TO_CLIENT_URL =
  "/v1/erp-service/pay/send-pre-payment-to-client";
const COPY_PRE_PAYMENT_LINK_URL = "/v1/erp-service/pay/copy-pre-payment-link";
const GET_PRE_PAYMENT_WHATSAPP_MESSAGE_URL =
  "/v1/erp-service/pay/get-pre-payment-whats-app-message";
const CREATE_PAYMENT_TRANSACTION_URL =
  "/v1/erp-service/receipts/create-payment-transaction";
const CREATE_DEBTS_PAYMENT_TRANSACTION_URL =
  "/v1/erp-service/receipts/create-debts-payment-transaction";
const GET_DEBTS_PAYMENT_BY_ID_URL =
  "/v1/erp-service/pay/get-debts-payment-by-id";

const GET_DOCUMENT_PDF_BY_NUMBER_URL =
  "/v1/erp-service/documents/get-document-pdf-by-number";

const sendDocumentToClientForPaymentApi: ICallAndSetData = async (
  callApi,
  setState,
  data
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    PAYMENT_URL,
    setState,
    data
  );
};

const getDocumentContactApi: ICallAndSetData = async (
  callApi,
  setState,
  data
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    DOCUMENT_CONTACT_URL,
    setState,
    data
  );
};

const getPrePaymentByIdApi: ICallAndSetData = async (
  callApi,
  setState,
  data
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    GET_PRE_PAYMENT_BY_ID_URL,
    setState,
    data
  );
};

const getStripePaymentRedirectUrlApi: ICallAndSetData = async (
  callApi,
  setState,
  data
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    GET_STRIPE_PAYMENT_REDIRECT_URL,
    setState,
    data
  );
};

const completeStripePaymentRequestApi: ICallAndSetData = async (
  callApi,
  setState,
  data
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    COMPLETE_STRIPE_PAYMENT_REQUEST_URL,
    setState,
    data,
    true,
    null,
    true
  );
};

const sendPrePaymentToClientApi: ICallAndSetData = async (
  callApi,
  setState,
  data
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    SEND_PRE_PAYMENT_TO_CLIENT_URL,
    setState,
    data
  );
};

const CopyPrePaymentLinkApi: ICallAndSetData = async (
  callApi,
  setState,
  data
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    COPY_PRE_PAYMENT_LINK_URL,
    setState,
    data
  );
};

const createPaymentTransactionApi: ICallAndSetData = async (
  callApi,
  setState,
  data
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    CREATE_PAYMENT_TRANSACTION_URL,
    setState,
    data,
    true,
    null,
    true
  );
};

const getDebtsPaymentByIdApi: ICallAndSetData = async (
  callApi,
  setState,
  data
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    GET_DEBTS_PAYMENT_BY_ID_URL,
    setState,
    data
  );
};

const createDebitsPaymentTransactionApi: ICallAndSetData = async (
  callApi,
  setState,
  data
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    CREATE_DEBTS_PAYMENT_TRANSACTION_URL,
    setState,
    data,
    true,
    null,
    true
  );
};

const getDocumentPdfByNumberApi: ICallAndSetData = async (
  callApi,
  setState,
  data
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    GET_DOCUMENT_PDF_BY_NUMBER_URL,
    setState,
    data
  );
};

const getPrePaymentWhatsAppMessageApi: ICallAndSetData = async (
  callApi,
  setState,
  data
) => {
  const { documentType, ...payload } = data || {};
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    `${GET_PRE_PAYMENT_WHATSAPP_MESSAGE_URL}/${documentType}`,
    setState,
    payload
  );
};

export {
  sendDocumentToClientForPaymentApi,
  getDocumentContactApi,
  getPrePaymentByIdApi,
  getStripePaymentRedirectUrlApi,
  completeStripePaymentRequestApi,
  sendPrePaymentToClientApi,
  CopyPrePaymentLinkApi,
  createPaymentTransactionApi,
  getDebtsPaymentByIdApi,
  createDebitsPaymentTransactionApi,
  getDocumentPdfByNumberApi,
  getPrePaymentWhatsAppMessageApi,
};
